/**************
 Global
 ***************/

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}


//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


// fetches watch metaobjects
let watches = [];
let selectedWatch = null;

function getWatches() {
    // request vehicle metaobjects from maltertech api
    return fetch('https://solacebands.s3.us-east-1.amazonaws.com/watches.json', {})
        .then(response => response.json())
        .then(data => {

            return data;
        })
        .catch(error => console.error('Error:', error));
}


// wait for the dom to load, then dispatch an event when the vehicle metaobjects are loaded
(function () {
    document.addEventListener("DOMContentLoaded", async function () {
        // parse watch metaobjects from json
        let watchData = await getWatches();


        // create watch objects
        // fill in watch variants with their IDs so we can swap them out later
        watchData.forEach(object => {
            let watch = {
                "handle": object.handle,
                "id": object.id,
                "manufacturer": object.fields[0].value,
                "model": object.fields[1].value,
                "size": object.fields[2].value,
                "variants": JSON.parse(object.fields[3].value) // array of variant ids
            }
            watches.push(watch);
        })
        
        // create list of variant ids
        let uniqueVariantIDs = [];
        watchData.forEach(object => {
            let variantData = JSON.parse(object.fields[3].value);
            variantData.forEach(variant => {
                if (!uniqueVariantIDs.includes(variant)) {
                    uniqueVariantIDs.push(variant);
                }
            });
        })

        // fetch variant data from Shopify Storefront API
        const productQueries = Array.from(uniqueVariantIDs).map((variantID, idx) => {
            return `variant_${idx}: node(id: "${variantID}") {
                id
                ... on ProductVariant {
                  id
                  title
                  priceV2 {
                    amount
                  }
                  product {
                    id
                    title
                    handle
                  }
                }
              }`;
        });
        const variantData = await client.request(
            `
            query CollectionProducts {
               ${productQueries}
            }
            `
        );

        // parse the variant data into a usable format
        let variants = {};
        for (const [key, value] of Object.entries(variantData.data)) {
            let variant = null;
            if (value) {
                variant = {
                    "id": value.id,
                    "title": value.title,
                    "price": value.priceV2.amount,
                    "product": {
                        "id": value.product.id.split("/").pop(),
                        "title": value.product.title,
                        "handle": value.product.handle
                    }
                };
                // add variant to variants object
                variants[value.id] = variant;
            }
        }

        // update watches with variant data
        // replace all variant IDs with their new data
        watches.forEach(watch => {
            let oldVariants = watch.variants;
            let newVariants = [];

            oldVariants.forEach(variantID => {
                let variant = variants[variantID];
                if (variant) {
                    variant.id = variant.id.split("/").pop();
                    newVariants.push(variant);
                }
            });
            watch.variants = newVariants;
        });


        // wait for all variants to be fetched
        let event = new Event('watchesLoaded');
        document.dispatchEvent(event);
        console.log("Watches loaded", watches);
    })
})();
